// extracted by mini-css-extract-plugin
module.exports = {"badge":"_Badge_badge__zdc1R","label":"_Badge_label__22TLL"};